export default () => Math.max(document.body.scrollTop, document.documentElement.scrollTop)
